import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface text-ink">
      <div className="rounded-3xl border border-slate-200 bg-white/90 p-10 text-center shadow-sm">
        <div className="text-xs uppercase tracking-widest text-slate-500">404</div>
        <h1 className="mt-3 text-3xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-slate-600">The page you are looking for does not exist.</p>
        <Link
          to="/"
          className="mt-6 inline-flex rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white"
        >
          Return home
        </Link>
      </div>
    </div>
  )
}

export default NotFound

